import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aa11c2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "posts page-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Manage Services")
], -1))
const _hoisted_2 = { class: "posts page" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-50" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add a New Service", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Featured Image", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "SEO", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Select a Category", -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<option value=\"none\" selected disabled hidden data-v-4aa11c2d>Select a Category</option><option value=\"Marketing\" data-v-4aa11c2d>Marketing</option><option value=\"App Development\" data-v-4aa11c2d>App Development</option><option value=\"Websites\" data-v-4aa11c2d>Websites</option><option value=\"Social Media\" data-v-4aa11c2d>Social Media</option><option value=\"Advertising\" data-v-4aa11c2d>Advertising</option><option value=\"Reputation Management\" data-v-4aa11c2d>Reputation Management</option><option value=\"Video Production\" data-v-4aa11c2d>Video Production</option><option value=\"NFT Services\" data-v-4aa11c2d>NFTs</option><option value=\"Metaverse Services\" data-v-4aa11c2d>Metaverse</option><option value=\"Graphic Design\" data-v-4aa11c2d>Graphic Design</option>", 11)
const _hoisted_20 = [
  _hoisted_9
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Frequently Asked Questions ", -1))
const _hoisted_22 = { class: "faq-wrapper" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Add FAQ"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn publish",
  type: "submit",
  value: "Publish"
}, null, -1))
const _hoisted_26 = { class: "col-50 current-post-column" }
const _hoisted_27 = {
  key: 0,
  class: "current-post-wrap"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "All Services", -1))
const _hoisted_29 = { class: "current-posts" }
const _hoisted_30 = { class: "post-content" }
const _hoisted_31 = { class: "post-title" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "view-post-wrap"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit Service", -1))
const _hoisted_35 = { class: "view-post" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Service Title:", -1))
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Short Description:", -1))
const _hoisted_41 = { key: 3 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Category:", -1))
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "content-wrap" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Frequently Asked Questions", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "faq-wrapper" }
const _hoisted_48 = { class: "answer" }
const _hoisted_49 = { class: "btn-row" }
const _hoisted_50 = {
  key: 0,
  class: "showEdit"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "edit-title" }, "Edit Service Content", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit Service Title", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit Short Description", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit Service Content", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Change Service Category", -1))
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<option value=\"none\" selected disabled hidden data-v-4aa11c2d>Select a Category</option><option value=\"Marketing\" data-v-4aa11c2d>Marketing</option><option value=\"App Development\" data-v-4aa11c2d>App Development</option><option value=\"Websites\" data-v-4aa11c2d>Websites</option><option value=\"Social Media\" data-v-4aa11c2d>Social Media</option><option value=\"Advertising\" data-v-4aa11c2d>Advertising</option><option value=\"Reputation Management\" data-v-4aa11c2d>Reputation Management</option><option value=\"Video Production\" data-v-4aa11c2d>Video Production</option><option value=\"NFT Services\" data-v-4aa11c2d>NFTs</option><option value=\"Metaverse Services\" data-v-4aa11c2d>Metaverse</option><option value=\"Graphic Design\" data-v-4aa11c2d>Graphic Design</option>", 11)
const _hoisted_67 = [
  _hoisted_56
]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Update Post Content"
}, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Change Featured Image", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Upload New Image", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Update Post Image"
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit SEO", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit Post SEO Title", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit SEO Url", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Edit SEO Description", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Publish"
}, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit Frequently Asked Questions ", -1))
const _hoisted_78 = { class: "faq-wrapper" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Add New Question", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Add FAQ"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_textbox = _resolveComponent("textbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", {
            class: "post-upload",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.uploadPost()), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "post-title",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postTitle) = $event)),
              placeholder: "Service Title",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.postTitle]
            ]),
            _createVNode(_component_textbox, { editor: _ctx.postContent }, null, 8, ["editor"]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shortDescription) = $event)),
              placeholder: "Short Description"
            }, null, 512), [
              [_vModelText, _ctx.shortDescription]
            ]),
            _hoisted_6,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newPhotoUpload && _ctx.newPhotoUpload(...args))),
              ref: "postImage",
              accept: "image/*",
              required: ""
            }, null, 544),
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seo.seoTitle) = $event)),
              placeholder: "SEO Title",
              minLength: "20",
              maxLength: "60",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.seo.seoTitle]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postURL) = $event)),
              placeholder: "New Service URL",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.postURL]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.seo.seoDescription) = $event)),
              placeholder: "Service Meta Description",
              rows: "5",
              minLength: "50",
              maxLength: "160",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.seo.seoDescription]
            ]),
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.postCategory) = $event)),
              required: ""
            }, _hoisted_20, 512), [
              [_vModelSelect, _ctx.postCategory]
            ]),
            _hoisted_21,
            (_ctx.new_faqs != '' && _ctx.new_faqs != null && _ctx.new_faqs != undefined)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.new_faqs, (faq, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "current-faqs",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h5", null, "Question " + _toDisplayString(index) + " of " + _toDisplayString(_ctx.new_faqs.length), 1),
                      _createElementVNode("h4", null, "Question: " + _toDisplayString(faq.title), 1),
                      _createElementVNode("p", null, _toDisplayString(faq.answer), 1),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (_ctx.deleteFAQ(index))
                      }, "Delete Question", 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.addFAQ()), ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "question",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.new_faq_question) = $event)),
                placeholder: "FAQ Question"
              }, null, 512), [
                [_vModelText, _ctx.new_faq_question]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "answer",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.new_faq_answer) = $event)),
                placeholder: "FAQ Answer"
              }, null, 512), [
                [_vModelText, _ctx.new_faq_answer]
              ]),
              _hoisted_24
            ], 32),
            _hoisted_25
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_26, [
          (!_ctx.showPost)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPosts, (post, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "current-post",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("h5", _hoisted_31, _toDisplayString(post.postTitle), 1),
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.viewPostData(post, index))
                        }, "View/Edit/Delete", 8, _hoisted_32)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showPost)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("h4", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showPost = false))
                }, "X Close View Service"),
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.viewPost.postPhoto != null)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.viewPost.postPhoto
                      }, null, 8, _hoisted_36))
                    : _createCommentVNode("", true),
                  (_ctx.viewPost.postTitle != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                        _hoisted_38,
                        _createTextVNode(" " + _toDisplayString(_ctx.viewPost.postTitle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewPost.shortDescription != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                        _hoisted_40,
                        _createTextVNode(" " + _toDisplayString(_ctx.viewPost.shortDescription), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewPost.postCategory != null)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                        _hoisted_42,
                        _createTextVNode(" " + _toDisplayString(_ctx.viewPost.postCategory), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.viewPost.postContent != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "post-data content-wrap",
                        innerHTML: _ctx.viewPost.postContent
                      }, null, 8, _hoisted_43))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    (_ctx.viewPost.faqs == null || _ctx.viewPost.faqs == undefined)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_46, "No FAQs created. Create some by clicking \"Edit Service\" in the button below."))
                      : _createCommentVNode("", true),
                    (_ctx.viewPost.faqs != null || _ctx.viewPost.faqs != undefined)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.viewPost.faqs, (faq, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "current-faqs",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("p", null, "Question " + _toDisplayString(index + 1) + " of " + _toDisplayString(_ctx.viewPost.faqs.length), 1),
                              _createElementVNode("h5", null, "Question: " + _toDisplayString(faq.title), 1),
                              _createElementVNode("p", _hoisted_48, _toDisplayString(faq.answer), 1)
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("button", {
                    class: "btn btn-left",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEdit = true))
                  }, "Edit Service"),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deletePost()))
                  }, "Delete Service")
                ]),
                (_ctx.showEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("h2", null, "Edit Service: \"" + _toDisplayString(_ctx.viewPost.postTitle) + "\"", 1),
                      _createElementVNode("h4", {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showEdit = false))
                      }, "X Close Edit Service"),
                      _hoisted_51,
                      _createElementVNode("form", {
                        class: "post-upload",
                        onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.editPostUpload()), ["prevent"])),
                        required: ""
                      }, [
                        _hoisted_52,
                        _withDirectives(_createElementVNode("input", {
                          class: "post-title",
                          type: "text",
                          name: "post_title",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editPost.postTitle) = $event)),
                          placeholder: "New Title",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.editPost.postTitle]
                        ]),
                        _hoisted_53,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "short_description",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editPost.shortDescription) = $event)),
                          placeholder: "New Short Description",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.editPost.shortDescription]
                        ]),
                        _hoisted_54,
                        _createVNode(_component_textbox, {
                          editor: _ctx.editPost.postContent,
                          name: "post_content"
                        }, null, 8, ["editor"]),
                        _hoisted_55,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editPost.postCategory) = $event)),
                          required: ""
                        }, _hoisted_67, 512), [
                          [_vModelSelect, _ctx.editPost.postCategory]
                        ]),
                        _hoisted_68
                      ], 32),
                      _hoisted_69,
                      _createElementVNode("form", {
                        class: "editImage",
                        onSubmit: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.editImageUpload()), ["prevent"]))
                      }, [
                        _hoisted_70,
                        _createElementVNode("input", {
                          type: "file",
                          name: "upload_new_image",
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.editPhotoUpload && _ctx.editPhotoUpload(...args))),
                          ref: "editPostImage",
                          accept: "image/*",
                          required: ""
                        }, null, 544),
                        _hoisted_71
                      ], 32),
                      _hoisted_72,
                      _createElementVNode("form", {
                        class: "post-upload",
                        onSubmit: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.editPostSEO()), ["prevent"]))
                      }, [
                        _hoisted_73,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "edit_seo_title",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editPost.seo.seoTitle) = $event)),
                          placeholder: "SEO Title",
                          minLength: "20",
                          maxLength: "60"
                        }, null, 512), [
                          [_vModelText, _ctx.editPost.seo.seoTitle]
                        ]),
                        _hoisted_74,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "edit_seo_url",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editPost.seo.postURL) = $event)),
                          placeholder: "New Post URL"
                        }, null, 512), [
                          [_vModelText, _ctx.editPost.seo.postURL]
                        ]),
                        _hoisted_75,
                        _withDirectives(_createElementVNode("textarea", {
                          name: "edit_seo_description",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editPost.seo.seoDescription) = $event)),
                          placeholder: "Post Meta Description",
                          rows: "5",
                          minLength: "50",
                          maxLength: "160"
                        }, null, 512), [
                          [_vModelText, _ctx.editPost.seo.seoDescription]
                        ]),
                        _hoisted_76
                      ], 32),
                      _hoisted_77,
                      (_ctx.edit_faqs != '' && _ctx.edit_faqs != null && _ctx.edit_faqs != undefined)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.edit_faqs, (faq, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "current-faqs",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("h5", null, "FAQ " + _toDisplayString(index + 1) + " of " + _toDisplayString(_ctx.edit_faqs.length), 1),
                                _createElementVNode("h4", null, "FAQ Question: " + _toDisplayString(faq.title), 1),
                                _createElementVNode("p", null, _toDisplayString(faq.answer), 1),
                                _createElementVNode("button", {
                                  class: "btn",
                                  onClick: ($event: any) => (_ctx.deleteEditFAQ(index))
                                }, "Delete Question", 8, _hoisted_79)
                              ])
                            ]))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_80,
                      _createElementVNode("form", {
                        class: "post-upload",
                        onSubmit: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.addFAQtoExistingFAQ()), ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "question",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.edit_faq_question) = $event)),
                          placeholder: "FAQ Question"
                        }, null, 512), [
                          [_vModelText, _ctx.edit_faq_question]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "answer",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.edit_faq_answer) = $event)),
                          placeholder: "FAQ Answer"
                        }, null, 512), [
                          [_vModelText, _ctx.edit_faq_answer]
                        ]),
                        _hoisted_81
                      ], 32),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.updateFAQsInDatabase()))
                      }, "Update FAQs")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}